import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import api from "../../Services/api"; // Axios instance
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import HashtagSelect from "../../component/HashtagSelect";
import "../AddBlog/index.css";

export default function AddBlog() {
  const alert = useSwal();
  const [formData, setFormData] = useState({
    heading: "",
    content: "",
    hashtags: "", // ✅ add this
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const handleChangereactuill = (value) => {
    setFormData({ ...formData, content: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        alert("error", "Only JPG, JPEG, PNG, WEBP files are allowed.");
        return;
      }
      setSelectedFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
setLoading(true);
    if (!formData.heading || !formData.content || !selectedFile) {
      alert("error", "Please fill all fields and select an image.");
      setLoading(false);
      return;
    }

    const data = new FormData();
    data.append("images", selectedFile);
    data.append("heading", formData.heading);
    data.append("content", formData.content);
    data.append("likes", 0);
    data.append("hashtags", formData.hashtags);

    try {
      const response = await api.post("/insertNews", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        await alert("success", "News added successfully!");
        navigate("/blog-view");
      } else {

        await alert("error", response.data.message || "Failed to add Blog.");
      }
    } catch (error) {
      console.error("Error adding news:", error.response || error);
      await alert("error", "Something went wrong. Please try again.");
    }finally {
      setLoading(false);
    }
  };

  //  Quill modules with image resize & drag-drop

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };


  return (
    <section className="dashboardpage">
      <Header pageTitle="Add Blog Details" backTo="/blog-view" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-start col-xl-6 col-12">
          <form className="form-fields d-flex" onSubmit={handleSubmit}>
            <div className="grid-container">
              <div className="input-container">
                <input
                  type="text"
                  id="heading"
                  name="heading"
                  placeholder="Enter Blog Title"
                  value={formData.heading}
                  onChange={handleChange}
                  required
                />
                <span className="underline"></span>
              </div>

              <div className="input-container description-container">
                <ReactQuill
                  value={formData.content}
                  onChange={handleChangereactuill}
                  theme="snow"
                  className="react-quill-wrapper"
                  modules={quillModules}
                />
              </div>

              <div className="input-container file-input-container">
                <input
                  type="file"
                  id="fileUpload"
                  onChange={handleFileChange}
                  className="file-input"
                  accept=".jpg, .jpeg, .png, .webp"
                />
                <span className="underline"></span>
                {selectedFile && (
                  <p className="file-name">{selectedFile.name}</p>
                )}
              </div>

              <HashtagSelect
                value={formData.hashtags}
                onChange={(hashtags) => setFormData((prev) => ({ ...prev, hashtags }))}
              />


            <button className="btn btn-purpal" type="submit" disabled={loading}>
  {loading ? "Submitting..." : "Submit"}
</button>
              {/* <button className="btn btn-purpal" type="submit">
                Submit
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
